import React from 'react';
import { Stack, Typography } from '@mui/material';
import GymIcon from '../assets/icons/icon_3.png'
// import { borderTop } from '@mui/system';

const BodyPart = ({ item, setBodyPart, bodyPart }) => {
  return (
    <Stack type='button' alignItems='center' justifyContent='center' className='bodyPart-card'

      sx={{
        borderTop: bodyPart === item ? '4px solid #ff2625' : '',
        backgroundColor: '#fff',
        width: '150px',
        height: '150px',
        cursor: 'pointer',
        gap: '15px'
      }}
      onClick={() => {
        setBodyPart(item);
        window.scrollTo({ top: 1800, left: 100, behavior: 'smooth' });
      }}
    // sx={
    //   bodyPart === item ? {borderTop : '4px solid #ff2625',
    //   backgroundColor: '#fff',
    //   width: '150px',
    //   height: '150px',
    //   cursor: 'pointer',
    //   gap: '15px' } : {
    //     backgroundColor: '#fff',
    //   width: '150px',
    //   height: '150px',
    //   cursor: 'pointer',
    //   gap: '15px'
    //   }
    // }
    >
      <img src={GymIcon} alt="icon" style={{ width: '40px', height: '40px' }} />
      <Typography fontSize='18px' textTransform='capitalize' fontWeight='bold' color='#3a1212'>
        {item}
      </Typography>
    </Stack>
  )
}

export default BodyPart